import type { LucideIcon } from 'lucide-react';
import {
  Users,
  Radio,
  MapPin,
  MapPinned,
  MessageSquare,
  BrainCircuit,
  PenTool,
  History,
  Settings,
  ShieldCheck,
  Timer,
} from 'lucide-react';
import echoIcon from '@/assets/echo-icon.png';

/** Core panel IDs (always present regardless of plugins) */
export type CorePanelId =
  | 'contacts'
  | 'echo'
  | 'marker'
  | 'chat'
  | 'ai'
  | 'tools'
  | 'replay'
  | 'locations'
  | 'countdown'
  | 'admin'
  | 'settings';

/** Navigation item definition for the icon rail */
export interface NavItem {
  id: string;
  label: string;
  icon: LucideIcon;
  /** Optional image asset path (e.g. echo-icon.png) used instead of Lucide icon */
  iconAsset?: string;
  /** Only shown to unit admins */
  adminOnly?: boolean;
  /** Kept out of the icon rail (the panel itself stays available to other surfaces) */
  hidden?: boolean;
}

/** Ordered list of core navigation items displayed in the icon rail */
export const CORE_NAV_ITEMS: readonly NavItem[] = [
  // Unit identity is the anchor of the workspace — pinned to the top of the rail.
  { id: 'admin', label: 'Unit', icon: ShieldCheck },
  { id: 'contacts', label: 'Contacts', icon: Users },
  { id: 'locations', label: 'Locations', icon: MapPinned },
  { id: 'echo', label: 'Echo', icon: Radio, iconAsset: echoIcon },
  { id: 'marker', label: 'Marker', icon: MapPin },
  { id: 'tools', label: 'Tools', icon: PenTool },
  { id: 'replay', label: 'Replay', icon: History },
  { id: 'countdown', label: 'Countdown', icon: Timer },
  { id: 'chat', label: 'Chat', icon: MessageSquare },
  // Hidden while the floating AI chat bubble is the primary entry point — flip to re-enable.
  { id: 'ai', label: 'VTAK AI', icon: BrainCircuit, hidden: true },
  // Opened from the rail footer's gear button, not the main nav list.
  { id: 'settings', label: 'Settings', icon: Settings, hidden: true },
];
